import { useEffect, useRef } from 'react';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useDispatch, useSelector } from 'react-redux';
import { clearGeneralCosmetologicFees } from '../../../../appRedux/actions/Reports';
import { generalCosmetologicFeesReportConst } from '../../../../constants';
import { formatPrice } from '../../../../util/formatPrice';
import { formatFileName } from '../../../../util/strings';
import { ExportButton } from '../../../uiComponents/ExportButton';
import { ReportTableHeader } from '../../../uiComponents/ReportTableHeader';
import { GeneralCosmetologicFeesFilters } from '../../ReportFilter/GeneralCosmetologicFeesFilter';
import { DataNotFound } from '../DataNotFound';

export const GeneralCosmetologicFeesReport = () => {
  const tableRef = useRef(null);
  const dispatch = useDispatch();
  const { generalCosmetologicFees } = useSelector((state) => state.reports);
  const { fullname, role } = useSelector((state) => state.userAuth);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: formatFileName(generalCosmetologicFeesReportConst.title),
    sheet: generalCosmetologicFeesReportConst.title,
  });
  const hasData = !!Object.keys(generalCosmetologicFees).length;
  const header = generalCosmetologicFeesReportConst.header;
  let total = 0;

  useEffect(() => {
    dispatch(clearGeneralCosmetologicFees());
  }, [dispatch]);

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <ExportButton onDownload={onDownload} disabled={!hasData} />
        <GeneralCosmetologicFeesFilters />
      </div>

      <div ref={tableRef}>
        {hasData ? (
          <table style={{ margin: '0 auto' }}>
            <ReportTableHeader
              user={fullname}
              role={role}
              title={generalCosmetologicFeesReportConst.title}
              col1={5}
              col2={0}
              col3={9}
            />
            <tbody>
              <tr>
                {header?.map((item, key) => (
                  <th
                    key={key}
                    colSpan={3}
                    style={{ border: '1px solid black', padding: '15px' }}
                  >
                    {item}
                  </th>
                ))}
              </tr>
              {generalCosmetologicFees?.map((row, key) => {
                total = Number(row.commission) + total;

                return (
                  <tr key={key}>
                    <td
                      colSpan={3}
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                        padding: '15px',
                      }}
                    >
                      {row.cosmetologist}
                    </td>
                    <td
                      colSpan={3}
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                      }}
                    >
                      {row.percent}%
                    </td>
                    <td
                      colSpan={3}
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                      }}
                    >
                      {formatPrice(row.commission)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={7}
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                    backgroundColor: '#e6e9eb',
                    padding: '15px',
                  }}
                >
                  <h4>TOTAL DE PAGO DE COMISIONES COSMETOLOGICAS</h4>
                </td>
                <td
                  colSpan={2}
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                    backgroundColor: '#e6e9eb',
                    padding: '5px',
                  }}
                >
                  {formatPrice(total)}
                </td>
              </tr>
            </tfoot>
          </table>
        ) : (
          <DataNotFound />
        )}
      </div>
    </div>
  );
};
